/**
 * Окна, которые не заводят собственного стора, но занимают экран не меньше остальных.
 *
 * Отдельный модуль, а не флаг в `app-update`, потому что это не состояние приложения, а факт
 * «прямо сейчас с человеком разговаривает кто-то другой». Читает его только `isScreenBusy`.
 */
let postNudgeVisible = false;

/** Окно «назначь сбор», которое встречает человека сразу после созданной заявки. */
export const setPostNudgeVisible = (visible: boolean) => {
  postNudgeVisible = visible;
};

export const isPostNudgeVisible = () => postNudgeVisible;
